import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  DoDoNot,
} from './DocumentPage';

const AccessingTrailersDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Accessing Trailers – Safe System of Work"
    documentHeading="Safe System of Work: Accessing Trailers"
    meta={[
      ['Document Reference', 'PVS-SSOW-AT'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Activity', 'Accessing trailers during delivery / collection and associated operations'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Accessing Trailers – Safe System of Work',
      documentReference: 'PVS-SSOW-AT',
      processActivity: 'Accessing Trailers',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Introduction">
      <Paragraph>
        Accessing trailers is a common activity that drivers and others often need to do as part of
        their job. The main hazard when accessing trailers is the risk of a trip, slip or fall
        resulting in injuries such as cuts, bruises, broken bones and even fatalities. Factors which
        could cause a trip, slip or fall include defects with safety devices, spills or bad weather
        conditions such as ice.
      </Paragraph>
    </Section>

    <Section number="2" title="Safe System of Work">
      <DoDoNot
        doItems={[
          'Carry out pre-use checks on the vehicle and associated safety equipment. This means checking that steps and handholds are in good, working condition. Report any defects to your Manager or Supervisor.',
          'Take time to climb down from the trailer facing the vehicle making sure to use assistance such as handholds.',
          'Always wear appropriate PPE such as hi-visibility clothing and safety footwear.',
          'Check for uneven surfaces e.g. potholes etc which may cause a slip prior to stepping off the trailer.',
          'Keep walking areas clean and tidy.',
          'Keep the load area tidy – pick up and tidy any loose ropes, straps, packaging etc.',
          'Clean up spillages immediately.',
          'Check that the straps are safely stored on curtain siders and not left on the trailer.',
          'Where possible, work at least one metre from the edge of the vehicle.',
          'When applicable use safety equipment such as steps and restraint belts.',
          'Pay attention to weather conditions such as wet, icy or windy conditions as well as the surface being walked on.',
          'Wear well-fitting safety footwear when working on vehicles.',
          'Be vigilant of passing vehicles.',
        ]}
        doNotItems={[
          'Jump. Jumping is bad for your knees in the long term and you are much more likely to fall and could break an arm or leg.',
          'Climb off the trailer forwards.',
          'Walk backwards on a trailer. Always face in the direction of travel.',
          'Use parts of the trailer not designed as hand or footholds (mudguards, bumpers, tracks, hooks and so on) to gain access to any part of the trailer.',
          'Work on the edges of the trailer.',
          'Rely on ropes, sheets or loads to support your weight as they can rip, tear or move.',
          'Rely on the curtain / edge protection to support your weight.',
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        IF YOU HAVE ANY QUESTIONS, PLEASE ASK YOUR MANAGER OR SUPERVISOR. You have a duty not only
        to protect your own health and safety but also to ensure that your actions do not put others
        around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default AccessingTrailersDoc;
